import { Box } from '@jfs/ui-new'

export const DefaultFormContainer = ({ children }) => <Box w={'100%'}>{children}</Box>
